import { defineChain } from "viem";
import { mainnet, sepolia } from "viem/chains";
const mezoMatsnetTestnet = defineChain({
    id: 31611,
    name: "Mezo Matsnet Testnet",
    nativeCurrency: {
        decimals: 18,
        name: "Bitcoin",
        symbol: "BTC",
    },
    rpcUrls: {
        default: { http: ["https://rpc.test.mezo.org"] },
    },
    blockExplorers: {
        default: {
            name: "Matsnet Testnet Explorer",
            url: "https://explorer.test.mezo.org",
        },
    },
    iconUrl: "https://explorer.test.mezo.org/assets/configs/network_icon.svg",
    iconBackground: "#fff",
    testnet: true,
});
export { mainnet, sepolia, mezoMatsnetTestnet };
export function getChainById(chainId) {
    return [mainnet, sepolia, mezoMatsnetTestnet].find((_chain) => _chain.id === chainId);
}
//# sourceMappingURL=chains.js.map